import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

export const recognizeRunFilters = z.object({
  excludedSources: z.array(z.nativeEnum(Provider)),
  excludedSalesChannels: z.array(z.string().trim().min(1)).default([]),
});

export type RecognizeRunFilters = z.infer<typeof recognizeRunFilters>;

export function shouldRunRecognize(
  provider: Provider,
  filters: RecognizeRunFilters,
  salesChannel: string | null | undefined,
): boolean {
  if (filters.excludedSources.includes(provider)) {
    return false;
  }
  if (!salesChannel) {
    return true;
  }
  const normalizedChannel = salesChannel.trim().toLowerCase();
  return !filters.excludedSalesChannels.some(
    (channel) => channel.trim().toLowerCase() === normalizedChannel,
  );
}
